module.exports = __webpack_public_path__ + "static/img/banner_00.00d2fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_00.jpg
// module id = Ldr1
// module chunks = 9